module.exports = __webpack_public_path__ + "static/media/landing_pro_image_hero.6d20c1f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing_pro_image_hero.png
// module id = 2083
// module chunks = 0